import LoadsConstants from '../../../../../pages/business/loads/constants';
import i18next from '../../../../../lib/i18n';
import { truncateString } from '../../../../../utils/string-utils';

const MAX_CHARACTERS_BEFORE_TRUNCATE_MESSAGES = 55;
const MAX_CHARACTERS_BEFORE_TRUNCATE = 42;

const getSuspensionReasonLength = (
    suspensionReason: string | undefined,
): number => {
    return suspensionReason ? suspensionReason.length : 0;
};

const truncateText = (text: string, indexToTruncate: number): string => {
    if (text == null) {
        return LoadsConstants.NO_INFO_TEXT;
    }
    return truncateString(text, indexToTruncate);
};

export const getCardCursor = (numberOfSelectedCards: number) => {
    return numberOfSelectedCards ? 'pointer' : 'default';
};

export const getFormattedDescription = (description: string): string => {
    return description?.length < MAX_CHARACTERS_BEFORE_TRUNCATE
        ? description
        : truncateText(description, MAX_CHARACTERS_BEFORE_TRUNCATE);
};

export const suspensionMessage = (suspensionReason: string | undefined) => {
    if (
        getSuspensionReasonLength(suspensionReason) <
        MAX_CHARACTERS_BEFORE_TRUNCATE_MESSAGES
    ) {
        return suspensionReason;
    }

    return truncateText(
        suspensionReason!,
        MAX_CHARACTERS_BEFORE_TRUNCATE_MESSAGES,
    );
};

export const noRatesMessage = (suspensionReason?: string) =>
    i18next.t(`Loads.${suspensionReason}`);
